import { IModalProps, Modal, Button } from '@/shared/ui';
import Copy from '@/assets/icons/thank-you/copy.svg';

type IProps = Omit<IModalProps, 'children'>;

const GreyHeadingAndSubheading = ({ heading, subText }: { heading: string; subText: string }) => {
    return (
        <div className="flex flex-col items-start justify-center">
            <span className="mb-[5px] block font-atkinsonBold text-12 text-[#9FA4A1] sm:text-16">{heading}</span>
            <span className="font-atkinson block text-14 sm:text-20">{subText}</span>
        </div>
    );
};

export default (props: IProps) => {
    const handleCopy = () => {
        const prescriptionText =
            'AmeriPharma MedBox\n' +
            '23041 Avenida De La Carlota\n' +
            'Suite 210 & 310\n' +
            'Laguna Hills, CA 92653\n' +
            'NPI: 1114387990\n' +
            'Phone: (800) 270-7091\n' +
            'Fax: (800) 951-7948';
        navigator.clipboard.writeText(prescriptionText);
    };

    return (
        <Modal
            {...props}
            className=""
            contentClassName="px-[20px] pb-[20px] pt-[30px] sm:px-[40px] sm:py-[40px]"
            dataTestId="ask-prescriber"
        >
            <div className="flex flex-col items-center justify-center gap-[20px]" data-testid="ask-prescriber-container">
                <span className="flex flex-col gap-3 text-center">
                    <span className="font-agrandir text-25 sm:text-30">Ask your prescriber to send your medications here</span>
                    <span className="font-atkinson text-15 sm:text-20">
                        By asking your prescriber to send your prescriptions directly to us, you can avoid the wait for your current
                        pharmacy to process a transfer request.
                    </span>
                </span>

                <div className="flex w-full flex-col rounded-xl border-1 border-grey-500 shadow-askPresc">
                    <div className="flex flex-col gap-2 px-[30px] py-[20px]">
                        <div className="flex flex-col items-start justify-center">
                            <span className="mb-[5px] block font-atkinsonBold text-12 text-[#9FA4A1] sm:text-16">
                                Electronic Prescription
                            </span>
                            <span className="font-atkinson block">AmeriPharma MedBox</span>
                            <span className="font-atkinson block">
                                23041 Avenida De La Carlota, Suite 210 & 310, Laguna Hills, CA{' '}
                                <span className="hidden sm:inline">92653</span>
                            </span>
                            <span className="font-atkinson block sm:hidden">92653</span>
                            <span className="font-atkinson block">NPI: 1114387990</span>
                        </div>
                        <GreyHeadingAndSubheading heading="Phone" subText="(800) 270-7091" />
                        <GreyHeadingAndSubheading heading="Fax" subText="(800) 951-7948" />
                    </div>
                    <div className="border-t-[1px] border-grey-500" />
                    <div
                        data-testid="copy-information-container"
                        onClick={handleCopy}
                        className="duration-600 flex cursor-pointer items-center justify-center gap-2.5 py-[20px] transition-opacity active:opacity-30"
                    >
                        <img src={Copy} alt="ic" />
                        <span data-testid="copy-information-text" className="font-atkinson text-16 text-primary sm:text-21">
                            Copy Information{' '}
                        </span>
                    </div>
                </div>
                <Button className="w-full sm:mt-[7px]" showEndIcon onClick={props.onClose} testId="button-ask-prescriber-close">
                    Close
                </Button>
            </div>
        </Modal>
    );
};
